import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router';

const RequestPassword = () => import('@/views/RequestPassword.vue');
const RequestPasswordConfirmation = () =>
  import('@/views/RequestPasswordConfirmation.vue');
const SetNewPassword = () => import('@/views/SetNewPassword.vue');
const SetNewPasswordConfirmation = () =>
  import('@/views/SetNewPasswordConfirmation.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'requestPassword' },
  },
  {
    path: '/request-password',
    name: 'requestPassword',
    component: RequestPassword,
  },
  {
    path: '/request-password-confirmation',
    name: 'requestPasswordConfirmation',
    component: RequestPasswordConfirmation,
  },
  {
    path: '/set-new-password',
    name: 'setNewPassword',
    component: SetNewPassword,
  },
  {
    path: '/set-new-password-confirmation',
    name: 'SetNewPasswordConfirmation',
    component: SetNewPasswordConfirmation,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
